export default __webpack_public_path__ + "static/dr-sumanth-07acbbdf9f79be16d15d9a40ca21dd28.jpg";